"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedEffect = void 0;
var React = require("react");
/**
 * This is not tested! Use at your own risk.
 */
function useDebouncedEffect(callback, timeout, deps) {
    // This deps array was noncompliant before we enabled the lint rule.
    // The better thing to do might be to require the caller to memoize the callback, instead of
    // doing it in the hook.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttled = React.useCallback(callback, deps);
    React.useEffect(function () {
        var handler = setTimeout(function () { return void throttled(); }, timeout);
        return function () { return clearTimeout(handler); };
    }, 
    // This deps array was noncompliant before we enabled the lint rule.
    // It's probably safe to add `throttled` to the array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [callback, timeout]);
}
exports.useDebouncedEffect = useDebouncedEffect;
//# sourceMappingURL=useDebouncedEffect.js.map